export default "__VITE_ASSET__TG9kjkqp__"